const setStorageItem = (key, value) => {
  let storage = window.localStorage;
  storage.setItem(key, value);
};
const getStorageItem = item => {
  let storage = window.localStorage;
  return storage.getItem(item);
};

export { setStorageItem, getStorageItem };
